import * as React from 'react';

import { MainBase } from '@common/containers/Main';

import { IMainProps } from './types';

export class Main extends React.Component<IMainProps> {

	render() {
		return (
			<MainBase />
		);
	}

}